import ServiceList from './ServiceList';
import ServiceEdit from './ServiceEdit';

export default {
  name: 'service',
  list: ServiceList,
  edit: ServiceEdit,
};
